import React from 'react';

const SvgNoBooked = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 400 310"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...props}
  >
    <defs>
      <path id="no-booked_svg__a" d="M2.44 2.618L.04.223l2.4 2.395" />
      <path id="no-booked_svg__c" d="M5.543 5.715L.064.248l5.479 5.467" />
      <path id="no-booked_svg__e" d="M2.26 2.016L.323.084 2.26 2.016" />
      <path id="no-booked_svg__g" d="M.026 19.233L7.795 2.475 5.396.082l2.399 2.393L.026 19.233" />
      <path id="no-booked_svg__i" d="M2.697.474L.297.465l2.4.01" />
      <path id="no-booked_svg__k" d="M89.248 289.2h25v19.729h-25z" />
      <path id="no-booked_svg__l" d="M.51 22.344L.59.18.51 22.344" />
      <path id="no-booked_svg__n" d="M2.78 2.782L.38.386l2.4 2.395" />
      <path d="M6.352 6.347L.24.247l6.113 6.1" id="no-booked_svg__p" />
      <path id="no-booked_svg__r" d="M3.186 20.943L.215.082l2.97 20.86" />
      <path
        d="M85.344.408h.047-.047zm-29.947 0h1.54-1.54zm-27.595 0h2.4-2.4zM.207.408h2.4-2.4z"
        id="no-booked_svg__t"
      />
      <path id="no-booked_svg__v" d="M.355.407h12.973H.355z" />
      <path id="no-booked_svg__x" d="M.067.407h25.195H.067z" />
      <path d="M25.345.408h-7.247 7.247M1.19.408H.15h1.04" id="no-booked_svg__z" />
      <path
        d="M16.843.408h5.187-5.187zm-8.398 0h5.187-5.187zm-8.398 0h5.187H.047z"
        id="no-booked_svg__B"
      />
      <path id="no-booked_svg__D" d="M.317.407h15.269H.316z" />
      <path id="no-booked_svg__F" d="M1.733 7.89H.127V.36h1.606H.127v7.53h1.606" />
      <path id="no-booked_svg__H" d="M.407.287h25.195H.407z" />
      <path id="no-booked_svg__J" d="M.067.287h25.195H.067z" />
      <path id="no-booked_svg__L" d="M.15.287h25.195H.15z" />
      <path id="no-booked_svg__N" d="M.234.287h25.195H.234z" />
      <path id="no-booked_svg__P" d="M.317.287h25.195H.317z" />
      <path id="no-booked_svg__R" d="M.4.287h4.346H.4z" />
      <path id="no-booked_svg__T" d="M.025.812l2.4-.668-2.4.668" />
      <path id="no-booked_svg__V" d="M.309 3.1L9.993.407.31 3.101" />
      <path id="no-booked_svg__X" d="M5.104 5.36L.076.407 5.104 5.36" />
      <path id="no-booked_svg__Z" d="M1.815 1.995L.143.327l1.672 1.668" />
      <path id="no-booked_svg__ab" d="M.328 20.457l10.703-9.661L.4.062l10.63 10.734-10.703 9.66" />
      <path id="no-booked_svg__ad" d="M.167 44.955L.327.182l-.16 44.773" />
      <path id="no-booked_svg__af" d="M.4 7.243L.428.01.401 7.243" />
      <path id="no-booked_svg__ah" d="M2.523 2.598L.123.003l2.4 2.594" />
      <path id="no-booked_svg__aj" d="M12.63 2.097H2.288L.407.063l1.88 2.034H12.63" />
      <path id="no-booked_svg__al" d="M1.944.53L.001.52l1.943.008" />
      <path id="no-booked_svg__an" d="M.349.407h8.98H.35z" />
    </defs>
    <g fill="none" fillRule="evenodd">
      <g transform="translate(114.7 9)">
        <mask id="no-booked_svg__b" fill="#fff">
          <use xlinkHref="#no-booked_svg__a" />
        </mask>
        <path fill="#4C4C4C" mask="url(#no-booked_svg__b)" d="M2.44 2.618L.04.223l2.4 2.395" />
      </g>
      <g transform="translate(109.197 3.51)">
        <mask id="no-booked_svg__d" fill="#fff">
          <use xlinkHref="#no-booked_svg__c" />
        </mask>
        <path fill="#4C4C4C" mask="url(#no-booked_svg__d)" d="M5.543 5.715L.064.248l5.479 5.467" />
      </g>
      <g transform="translate(116.816 11.535)">
        <mask id="no-booked_svg__f" fill="#fff">
          <use xlinkHref="#no-booked_svg__e" />
        </mask>
        <path fill="#4C4C4C" mask="url(#no-booked_svg__f)" d="M2.26 2.016L.323.084 2.26 2.016" />
      </g>
      <path fill="#FFF" d="M122.348 164.43h165.387V8.974H122.348z" />
      <path fill="#F4F6F7" d="M203.499 164.43h3.202V10.664h-3.202z" />
      <path fill="#E2E6E8" d="M285.544 166.12h3.115V9.065h-3.115z" />
      <path fill="#F4F6F7" d="M121.822 12.261h165.913V9.066H121.822z" />
      <path fill="#E2E6E8" d="M120.747 164.43h3.202V9.066h-3.202z" />
      <path fill="#F4F6F7" d="M120.747 166.027h167.64v-3.195h-167.64z" />
      <path
        d="M115.97 1.82h27.088v215.848c-33.489 1.43-53.99 1.394-61.506-.11-4.82-38.414 6.652-110.327 34.417-215.738zM292.467 1.82h-27.089v215.848c33.489 1.43 53.99 1.394 61.506-.11 4.82-38.414-6.652-110.327-34.417-215.738z"
        fill="#FFF1E4"
      />
      <g transform="translate(106.234 289.476)">
        <mask id="no-booked_svg__h" fill="#fff">
          <use xlinkHref="#no-booked_svg__g" />
        </mask>
        <use fill="#4C4C4C" xlinkHref="#no-booked_svg__g" />
        <path
          fill="#4C4C4C"
          mask="url(#no-booked_svg__h)"
          d="M.026 19.233L7.795 2.475 5.396.082l2.399 2.393L.026 19.233"
        />
      </g>
      <g transform="translate(59.253 308.062)">
        <mask id="no-booked_svg__j" fill="#fff">
          <use xlinkHref="#no-booked_svg__i" />
        </mask>
        <use fill="#4C4C4C" xlinkHref="#no-booked_svg__i" />
        <path fill="#4C4C4C" mask="url(#no-booked_svg__j)" d="M2.697.474L.297.465l2.4.01" />
      </g>
      <image
        x={89.248}
        y={289.201}
        width={24.999}
        height={19.728}
        xlinkHref="data:image/png;base64,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"
      />
      <use fill="#4C4C4C" xlinkHref="#no-booked_svg__k" />
      <g transform="translate(94.806 228.228)">
        <mask id="no-booked_svg__m" fill="#fff">
          <use xlinkHref="#no-booked_svg__l" />
        </mask>
        <path mask="url(#no-booked_svg__m)" d="M.51 22.344L.59.18.51 22.344" />
      </g>
      <g transform="translate(86.765 147.126)">
        <mask id="no-booked_svg__o" fill="#fff">
          <use xlinkHref="#no-booked_svg__n" />
        </mask>
        <use fill="#4C4C4C" xlinkHref="#no-booked_svg__n" />
        <path fill="#4C4C4C" mask="url(#no-booked_svg__o)" d="M2.78 2.782L.38.386l2.4 2.395" />
      </g>
      <g transform="translate(89.304 149.66)">
        <mask id="no-booked_svg__q" fill="#fff">
          <use xlinkHref="#no-booked_svg__p" />
        </mask>
        <use fill="#4C4C4C" xlinkHref="#no-booked_svg__p" />
        <path d="M6.352 6.347L.24.247l6.113 6.1" fill="#4C4C4C" mask="url(#no-booked_svg__q)" />
      </g>
      <g transform="translate(285.272 289.476)">
        <mask id="no-booked_svg__s" fill="#fff">
          <use xlinkHref="#no-booked_svg__r" />
        </mask>
        <use fill="#4C4C4C" xlinkHref="#no-booked_svg__r" />
        <path fill="#4C4C4C" mask="url(#no-booked_svg__s)" d="M3.186 20.943L.215.082l2.97 20.86" />
      </g>
      <g transform="translate(169.723 193.59)">
        <mask id="no-booked_svg__u" fill="#fff">
          <use xlinkHref="#no-booked_svg__t" />
        </mask>
        <path
          d="M85.344.408h.047-.047zm-29.947 0h1.54-1.54zm-27.595 0h2.4-2.4zM.207.408h2.4-2.4z"
          mask="url(#no-booked_svg__u)"
        />
      </g>
      <g transform="translate(156.602 193.59)">
        <mask id="no-booked_svg__w" fill="#fff">
          <use xlinkHref="#no-booked_svg__v" />
        </mask>
        <path mask="url(#no-booked_svg__w)" d="M.355.408h12.973H.355z" />
      </g>
      <g transform="translate(172.262 193.59)">
        <mask id="no-booked_svg__y" fill="#fff">
          <use xlinkHref="#no-booked_svg__x" />
        </mask>
        <path mask="url(#no-booked_svg__y)" d="M.067.408h25.195H.067z" />
      </g>
      <g transform="translate(199.774 193.59)">
        <mask id="no-booked_svg__A" fill="#fff">
          <use xlinkHref="#no-booked_svg__z" />
        </mask>
        <path d="M25.345.408h-7.247 7.247M1.19.408H.15h1.04" mask="url(#no-booked_svg__A)" />
      </g>
      <g transform="translate(229.825 193.59)">
        <mask id="no-booked_svg__C" fill="#fff">
          <use xlinkHref="#no-booked_svg__B" />
        </mask>
        <path
          d="M16.843.408h5.187-5.187zm-8.398 0h5.187-5.187zm-8.398 0h5.187H.047z"
          mask="url(#no-booked_svg__C)"
        />
      </g>
      <g transform="translate(254.797 193.59)">
        <mask id="no-booked_svg__E" fill="#fff">
          <use xlinkHref="#no-booked_svg__D" />
        </mask>
        <path mask="url(#no-booked_svg__E)" d="M.317.408h15.269H.316z" />
      </g>
      <g transform="translate(12.186 77.168)">
        <image
          x={14.099}
          y={32.19}
          width={1.839}
          height={8.576}
          xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAqCAYAAABhqXGIAAAEGWlDQ1BrQ0dDb2xvclNwYWNlR2VuZXJpY1JHQgAAOI2NVV1oHFUUPrtzZyMkzlNsNIV0qD8NJQ2TVjShtLp/3d02bpZJNtoi6GT27s6Yyc44M7v9oU9FUHwx6psUxL+3gCAo9Q/bPrQvlQol2tQgKD60+INQ6Ium65k7M5lpurHeZe58853vnnvuuWfvBei5qliWkRQBFpquLRcy4nOHj4g9K5CEh6AXBqFXUR0rXalMAjZPC3e1W99Dwntf2dXd/p+tt0YdFSBxH2Kz5qgLiI8B8KdVy3YBevqRHz/qWh72Yui3MUDEL3q44WPXw3M+fo1pZuQs4tOIBVVTaoiXEI/MxfhGDPsxsNZfoE1q66ro5aJim3XdoLFw72H+n23BaIXzbcOnz5mfPoTvYVz7KzUl5+FRxEuqkp9G/Ajia219thzg25abkRE/BpDc3pqvphHvRFys2weqvp+krbWKIX7nhDbzLOItiM8358pTwdirqpPFnMF2xLc1WvLyOwTAibpbmvHHcvttU57y5+XqNZrLe3lE/Pq8eUj2fXKfOe3pfOjzhJYtB/yll5SDFcSDiH+hRkH25+L+sdxKEAMZahrlSX8ukqMOWy/jXW2m6M9LDBc31B9LFuv6gVKg/0Szi3KAr1kGq1GMjU/aLbnq6/lRxc4XfJ98hTargX++DbMJBSiYMIe9Ck1YAxFkKEAG3xbYaKmDDgYyFK0UGYpfoWYXG+fAPPI6tJnNwb7ClP7IyF+D+bjOtCpkhz6CFrIa/I6sFtNl8auFXGMTP34sNwI/JhkgEtmDz14ySfaRcTIBInmKPE32kxyyE2Tv+thKbEVePDfW/byMM1Kmm0XdObS7oGD/MypMXFPXrCwOtoYjyyn7BV29/MZfsVzpLDdRtuIZnbpXzvlf+ev8MvYr/Gqk4H/kV/G3csdazLuyTMPsbFhzd1UabQbjFvDRmcWJxR3zcfHkVw9GfpbJmeev9F08WW8uDkaslwX6avlWGU6NRKz0g/SHtCy9J30o/ca9zX3Kfc19zn3BXQKRO8ud477hLnAfc1/G9mrzGlrfexZ5GLdn6ZZrrEohI2wVHhZywjbhUWEy8icMCGNCUdiBlq3r+xafL549HQ5jH+an+1y+LlYBifuxAvRN/lVVVOlwlCkdVm9NOL5BE4wkQ2SMlDZU97hX86EilU/lUmkQUztTE6mx1EEPh7OmdqBtAvv8HdWpbrJS6tJj3n0CWdM6busNzRV3S9KTYhqvNiqWmuroiKgYhshMjmhTh9ptWhsF7970j/SbMrsPE1suR5z7DMC+P/Hs+y7ijrQAlhyAgccjbhjPygfeBTjzhNqy28EdkUh8C+DU9+z2v/oyeH791OncxHOs5y2AtTc7nb/f73TWPkD/qwBnjX8BoJ98VQNcC+8AAAA6SURBVDgRY9y2ecN/RgZGBjCAUjA2IwMTmAkhIUpwkqOKoKGFM4QgEqPhNBpODKNBMBoEwOJgMJYFAO+aA3MEKuyfAAAAAElFTkSuQmCC"
        />
        <path
          d="M40.626 21.892c0 10.45-8.486 18.92-18.96 18.92-10.47 0-18.958-8.47-18.958-18.92 0-10.45 8.488-18.92 18.959-18.92 10.473 0 18.959 8.47 18.959 18.92"
          fill="#FFF"
        />
        <path
          d="M40.846 21.807c0 10.633-8.639 19.251-19.291 19.251-10.654 0-19.29-8.618-19.29-19.25S10.9 2.556 21.555 2.556c10.652 0 19.29 8.619 19.29 19.25"
          fill="#FFF"
        />
        <path
          fill="#E2E6E8"
          d="M21.018 5.631h1.296V1.034h-1.296zm18.236 5.17l.648 1.12-3.987 2.298-.648-1.12 3.987-2.299m-8.88-2.41l-1.121-.647 2.302-3.982 1.122.647-2.302 3.982m-9.357 34.434h1.296v-4.597h-1.296zM37.583 22.43h3.153v-1.293h-3.153zm-36.815 0h4.607v-1.293H.768zm6.636 7.075l.648 1.12-3.99 2.299-.647-1.12 3.99-2.3M8.051 13.1l-.648 1.12-3.989-2.298.648-1.12 3.99 2.298m6.093-5.785l-1.122.647-2.304-3.982 1.123-.646 2.303 3.98m25.756 24.49l-.648 1.12-3.987-2.3.648-1.12 3.987 2.3m-7.01 7.656l-1.12.647-2.303-3.982 1.121-.646 2.303 3.981m-21 .647l-1.123-.647 2.304-3.981 1.122.646-2.303 3.982m10.905-18.214a1.131 1.131 0 11-2.262-.003 1.131 1.131 0 012.262.003"
        />
        <path fill="#E2E6E8" d="M22.26 21.706l-1.111.186-2.89-17.238 1.112-.185 2.889 17.237" />
        <path fill="#E2E6E8" d="M22.287 22.067l-.54-.987 10.473-5.714.542.986-10.475 5.715" />
        <path
          d="M21.666 40.543c-10.47 0-18.96-8.471-18.96-18.92 0-10.45 8.49-18.922 18.96-18.922s18.96 8.472 18.96 18.921c0 10.45-8.49 18.921-18.96 18.921zm0-40.543C9.7 0 0 9.68 0 21.622s9.7 21.622 21.666 21.622c11.968 0 21.664-9.68 21.664-21.622C43.33 9.681 33.634 0 21.666 0z"
          fill="#FFF1E4"
        />
      </g>
      <g transform="translate(113.006 300.881)">
        <mask id="no-booked_svg__G" fill="#fff">
          <use xlinkHref="#no-booked_svg__F" />
        </mask>
        <use fill="#4C4C4C" xlinkHref="#no-booked_svg__F" />
        <path
          fill="#4C4C4C"
          mask="url(#no-booked_svg__G)"
          d="M1.733 7.89H.127V.36h1.606H.127v7.53h1.606"
        />
      </g>
      <g transform="translate(144.327 308.484)">
        <mask id="no-booked_svg__I" fill="#fff">
          <use xlinkHref="#no-booked_svg__H" />
        </mask>
        <use fill="#4C4C4C" xlinkHref="#no-booked_svg__H" />
        <path fill="#4C4C4C" mask="url(#no-booked_svg__I)" d="M.407.288h25.195H.407z" />
      </g>
      <g transform="translate(172.262 308.484)">
        <mask id="no-booked_svg__K" fill="#fff">
          <use xlinkHref="#no-booked_svg__J" />
        </mask>
        <use fill="#4C4C4C" xlinkHref="#no-booked_svg__J" />
        <path fill="#4C4C4C" mask="url(#no-booked_svg__K)" d="M.067.288h25.195H.067z" />
      </g>
      <g transform="translate(199.774 308.484)">
        <mask id="no-booked_svg__M" fill="#fff">
          <use xlinkHref="#no-booked_svg__L" />
        </mask>
        <use fill="#4C4C4C" xlinkHref="#no-booked_svg__L" />
        <path fill="#4C4C4C" mask="url(#no-booked_svg__M)" d="M.15.288h25.195H.15z" />
      </g>
      <g transform="translate(227.286 308.484)">
        <mask id="no-booked_svg__O" fill="#fff">
          <use xlinkHref="#no-booked_svg__N" />
        </mask>
        <use fill="#4C4C4C" xlinkHref="#no-booked_svg__N" />
        <path fill="#4C4C4C" mask="url(#no-booked_svg__O)" d="M.234.288h25.195H.234z" />
      </g>
      <g transform="translate(254.797 308.484)">
        <mask id="no-booked_svg__Q" fill="#fff">
          <use xlinkHref="#no-booked_svg__P" />
        </mask>
        <use fill="#4C4C4C" xlinkHref="#no-booked_svg__P" />
        <path fill="#4C4C4C" mask="url(#no-booked_svg__Q)" d="M.317.288h25.195H.317z" />
      </g>
      <g transform="translate(282.309 308.484)">
        <mask id="no-booked_svg__S" fill="#fff">
          <use xlinkHref="#no-booked_svg__R" />
        </mask>
        <use fill="#4C4C4C" xlinkHref="#no-booked_svg__R" />
        <path fill="#4C4C4C" mask="url(#no-booked_svg__S)" d="M.4.288h4.346H.4z" />
      </g>
      <g transform="translate(386.941 232.874)">
        <mask id="no-booked_svg__U" fill="#fff">
          <use xlinkHref="#no-booked_svg__T" />
        </mask>
        <path mask="url(#no-booked_svg__U)" d="M.025.812l2.4-.668-2.4.668" />
      </g>
      <g transform="translate(389.058 229.917)">
        <mask id="no-booked_svg__W" fill="#fff">
          <use xlinkHref="#no-booked_svg__V" />
        </mask>
        <path mask="url(#no-booked_svg__W)" d="M.309 3.1L9.993.407.31 3.101" />
      </g>
      <g transform="translate(381.862 164.022)">
        <mask id="no-booked_svg__Y" fill="#fff">
          <use xlinkHref="#no-booked_svg__X" />
        </mask>
        <path mask="url(#no-booked_svg__Y)" d="M5.104 5.36L.076.407 5.104 5.36" />
      </g>
      <g transform="translate(118.932 13.225)">
        <mask id="no-booked_svg__aa" fill="#fff">
          <use xlinkHref="#no-booked_svg__Z" />
        </mask>
        <path fill="#4C4C4C" mask="url(#no-booked_svg__aa)" d="M1.815 1.995L.143.327l1.672 1.668" />
      </g>
      <g transform="translate(95.23 163.178)">
        <mask id="no-booked_svg__ac" fill="#fff">
          <use xlinkHref="#no-booked_svg__ab" />
        </mask>
        <use fill="#4C4C4C" xlinkHref="#no-booked_svg__ab" />
        <path
          fill="#4C4C4C"
          mask="url(#no-booked_svg__ac)"
          d="M.328 20.457l10.703-9.661L.4.062l10.63 10.734-10.703 9.66"
        />
      </g>
      <g transform="translate(95.23 183.453)">
        <mask id="no-booked_svg__ae" fill="#fff">
          <use xlinkHref="#no-booked_svg__ad" />
        </mask>
        <path mask="url(#no-booked_svg__ae)" d="M.167 44.955L.327.182l-.16 44.773" />
      </g>
      <g transform="translate(95.23 155.997)">
        <mask id="no-booked_svg__ag" fill="#fff">
          <use xlinkHref="#no-booked_svg__af" />
        </mask>
        <use fill="#4C4C4C" xlinkHref="#no-booked_svg__af" />
        <path fill="#4C4C4C" mask="url(#no-booked_svg__ag)" d="M.4 7.243L.428.01.401 7.243" />
      </g>
      <g transform="translate(142.211 189.367)">
        <mask id="no-booked_svg__ai" fill="#fff">
          <use xlinkHref="#no-booked_svg__ah" />
        </mask>
        <path mask="url(#no-booked_svg__ai)" d="M2.523 2.598L.123.003l2.4 2.594" />
      </g>
      <g transform="translate(144.327 191.901)">
        <mask id="no-booked_svg__ak" fill="#fff">
          <use xlinkHref="#no-booked_svg__aj" />
        </mask>
        <path mask="url(#no-booked_svg__ak)" d="M12.63 2.097H2.288L.407.063l1.88 2.034H12.63" />
      </g>
      <path fill="#4C4C4C" d="M93.927 301.178h211.56v-11.894H93.927z" />
      <path fill="#F4F6F7" d="M332.103 303.139h67.777v-72.814h-67.777z" />
      <path
        fill="#F4F6F7"
        d="M331.968 309.575h15.198v-9.137h-15.198zm52.717 0h15.195v-9.137h-15.195z"
      />
      <path
        d="M368.321 246.204a2.326 2.326 0 01-2.329 2.324 2.327 2.327 0 01-2.328-2.324 2.327 2.327 0 012.328-2.324 2.327 2.327 0 012.33 2.324m0 37.042a2.326 2.326 0 01-2.33 2.324 2.327 2.327 0 01-2.328-2.324 2.327 2.327 0 012.328-2.324 2.326 2.326 0 012.33 2.324m-36.22-15.429h67.778v-1.085h-67.777z"
        fill="#FFF"
      />
      <g transform="translate(288.658 17.026)">
        <mask id="no-booked_svg__am" fill="#fff">
          <use xlinkHref="#no-booked_svg__al" />
        </mask>
        <path fill="#4C4C4C" mask="url(#no-booked_svg__am)" d="M1.944.53L.001.52l1.943.008" />
      </g>
      <image
        x={279.002}
        y={193.704}
        width={1.635}
        height={1.277}
        xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAGCAYAAAD+Bd/7AAAEGWlDQ1BrQ0dDb2xvclNwYWNlR2VuZXJpY1JHQgAAOI2NVV1oHFUUPrtzZyMkzlNsNIV0qD8NJQ2TVjShtLp/3d02bpZJNtoi6GT27s6Yyc44M7v9oU9FUHwx6psUxL+3gCAo9Q/bPrQvlQol2tQgKD60+INQ6Ium65k7M5lpurHeZe58853vnnvuuWfvBei5qliWkRQBFpquLRcy4nOHj4g9K5CEh6AXBqFXUR0rXalMAjZPC3e1W99Dwntf2dXd/p+tt0YdFSBxH2Kz5qgLiI8B8KdVy3YBevqRHz/qWh72Yui3MUDEL3q44WPXw3M+fo1pZuQs4tOIBVVTaoiXEI/MxfhGDPsxsNZfoE1q66ro5aJim3XdoLFw72H+n23BaIXzbcOnz5mfPoTvYVz7KzUl5+FRxEuqkp9G/Ajia219thzg25abkRE/BpDc3pqvphHvRFys2weqvp+krbWKIX7nhDbzLOItiM8358pTwdirqpPFnMF2xLc1WvLyOwTAibpbmvHHcvttU57y5+XqNZrLe3lE/Pq8eUj2fXKfOe3pfOjzhJYtB/yll5SDFcSDiH+hRkH25+L+sdxKEAMZahrlSX8ukqMOWy/jXW2m6M9LDBc31B9LFuv6gVKg/0Szi3KAr1kGq1GMjU/aLbnq6/lRxc4XfJ98hTargX++DbMJBSiYMIe9Ck1YAxFkKEAG3xbYaKmDDgYyFK0UGYpfoWYXG+fAPPI6tJnNwb7ClP7IyF+D+bjOtCpkhz6CFrIa/I6sFtNl8auFXGMTP34sNwI/JhkgEtmDz14ySfaRcTIBInmKPE32kxyyE2Tv+thKbEVePDfW/byMM1Kmm0XdObS7oGD/MypMXFPXrCwOtoYjyyn7BV29/MZfsVzpLDdRtuIZnbpXzvlf+ev8MvYr/Gqk4H/kV/G3csdazLuyTMPsbFhzd1UabQbjFvDRmcWJxR3zcfHkVw9GfpbJmeev9F08WW8uDkaslwX6avlWGU6NRKz0g/SHtCy9J30o/ca9zX3Kfc19zn3BXQKRO8ud477hLnAfc1/G9mrzGlrfexZ5GLdn6ZZrrEohI2wVHhZywjbhUWEy8icMCGNCUdiBlq3r+xafL549HQ5jH+an+1y+LlYBifuxAvRN/lVVVOlwlCkdVm9NOL5BE4wkQ2SMlDZU97hX86EilU/lUmkQUztTE6mx1EEPh7OmdqBtAvv8HdWpbrJS6tJj3n0CWdM6busNzRV3S9KTYhqvNiqWmuroiKgYhshMjmhTh9ptWhsF7970j/SbMrsPE1suR5z7DMC+P/Hs+y7ijrQAlhyAgccjbhjPygfeBTjzhNqy28EdkUh8C+DU9+z2v/oyeH791OncxHOs5y2AtTc7nb/f73TWPkD/qwBnjX8BoJ98VQNcC+8AAAAXSURBVAgdY7wVHfCfAQ9gwiMHlhoMCgDxFQKQu2hKBgAAAABJRU5ErkJggg=="
      />
      <g transform="translate(270.034 193.59)">
        <mask id="no-booked_svg__ao" fill="#fff">
          <use xlinkHref="#no-booked_svg__an" />
        </mask>
        <path mask="url(#no-booked_svg__ao)" d="M.349.408h8.98H.35z" />
      </g>
      <image
        x={279.002}
        y={193.704}
        width={1.635}
        height={0.669}
        xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAYAAACuyE5IAAAEGWlDQ1BrQ0dDb2xvclNwYWNlR2VuZXJpY1JHQgAAOI2NVV1oHFUUPrtzZyMkzlNsNIV0qD8NJQ2TVjShtLp/3d02bpZJNtoi6GT27s6Yyc44M7v9oU9FUHwx6psUxL+3gCAo9Q/bPrQvlQol2tQgKD60+INQ6Ium65k7M5lpurHeZe58853vnnvuuWfvBei5qliWkRQBFpquLRcy4nOHj4g9K5CEh6AXBqFXUR0rXalMAjZPC3e1W99Dwntf2dXd/p+tt0YdFSBxH2Kz5qgLiI8B8KdVy3YBevqRHz/qWh72Yui3MUDEL3q44WPXw3M+fo1pZuQs4tOIBVVTaoiXEI/MxfhGDPsxsNZfoE1q66ro5aJim3XdoLFw72H+n23BaIXzbcOnz5mfPoTvYVz7KzUl5+FRxEuqkp9G/Ajia219thzg25abkRE/BpDc3pqvphHvRFys2weqvp+krbWKIX7nhDbzLOItiM8358pTwdirqpPFnMF2xLc1WvLyOwTAibpbmvHHcvttU57y5+XqNZrLe3lE/Pq8eUj2fXKfOe3pfOjzhJYtB/yll5SDFcSDiH+hRkH25+L+sdxKEAMZahrlSX8ukqMOWy/jXW2m6M9LDBc31B9LFuv6gVKg/0Szi3KAr1kGq1GMjU/aLbnq6/lRxc4XfJ98hTargX++DbMJBSiYMIe9Ck1YAxFkKEAG3xbYaKmDDgYyFK0UGYpfoWYXG+fAPPI6tJnNwb7ClP7IyF+D+bjOtCpkhz6CFrIa/I6sFtNl8auFXGMTP34sNwI/JhkgEtmDz14ySfaRcTIBInmKPE32kxyyE2Tv+thKbEVePDfW/byMM1Kmm0XdObS7oGD/MypMXFPXrCwOtoYjyyn7BV29/MZfsVzpLDdRtuIZnbpXzvlf+ev8MvYr/Gqk4H/kV/G3csdazLuyTMPsbFhzd1UabQbjFvDRmcWJxR3zcfHkVw9GfpbJmeev9F08WW8uDkaslwX6avlWGU6NRKz0g/SHtCy9J30o/ca9zX3Kfc19zn3BXQKRO8ud477hLnAfc1/G9mrzGlrfexZ5GLdn6ZZrrEohI2wVHhZywjbhUWEy8icMCGNCUdiBlq3r+xafL549HQ5jH+an+1y+LlYBifuxAvRN/lVVVOlwlCkdVm9NOL5BE4wkQ2SMlDZU97hX86EilU/lUmkQUztTE6mx1EEPh7OmdqBtAvv8HdWpbrJS6tJj3n0CWdM6busNzRV3S9KTYhqvNiqWmuroiKgYhshMjmhTh9ptWhsF7970j/SbMrsPE1suR5z7DMC+P/Hs+y7ijrQAlhyAgccjbhjPygfeBTjzhNqy28EdkUh8C+DU9+z2v/oyeH791OncxHOs5y2AtTc7nb/f73TWPkD/qwBnjX8BoJ98VQNcC+8AAAAXSURBVAgdY3yfn/yfAQ9gwiMHliKoAAAK6QLGFyT/SwAAAABJRU5ErkJggg=="
      />
      <path
        d="M57.91 230.12H18.334c-.74 0-1.34-.65-1.34-1.452v-6.492c0-.803.6-1.453 1.34-1.453H57.91a29.783 29.783 0 000 9.397"
        fill="#FFF1E4"
      />
      <path
        d="M57.668 229.435h-38.02c-.663 0-1.2-.536-1.2-1.197v-5.35c0-.662.537-1.198 1.2-1.198h38.02c-.487 2.597-.509 5.142 0 7.745"
        fill="#FFF"
      />
      <path
        d="M95.11 289.59a1.604 1.604 0 01-1.607-1.603V180.1c0-.885.72-1.602 1.606-1.602.887 0 1.606.717 1.606 1.602v107.887c0 .885-.719 1.603-1.606 1.603"
        fill="#4C4C4C"
      />
      <path
        fill="#4C4C4C"
        d="M93.927 188.258h208.348v-3.206H93.927zm190.777 120.458h20.783v-7.538h-20.783z"
      />
      <path
        d="M302.275 289.795a1.604 1.604 0 01-1.606-1.602V180.306c0-.885.72-1.603 1.606-1.603.887 0 1.606.718 1.606 1.603v107.887c0 .885-.72 1.602-1.606 1.602m-199.986 7.952a1.605 1.605 0 01-1.606-1.603V188.258c0-.886.72-1.603 1.606-1.603.887 0 1.606.717 1.606 1.603v107.886c0 .886-.719 1.603-1.606 1.603m8.398 0a1.605 1.605 0 01-1.605-1.603V188.258c0-.886.719-1.603 1.605-1.603.887 0 1.606.717 1.606 1.603v107.886c0 .886-.719 1.603-1.606 1.603m8.4 0a1.605 1.605 0 01-1.607-1.603V188.258c0-.886.719-1.603 1.606-1.603.887 0 1.606.717 1.606 1.603v107.886c0 .886-.72 1.603-1.606 1.603m8.398 0a1.605 1.605 0 01-1.605-1.603V188.258c0-.886.719-1.603 1.605-1.603.887 0 1.606.717 1.606 1.603v107.886c0 .886-.719 1.603-1.606 1.603m8.399 0a1.604 1.604 0 01-1.606-1.603V188.258c0-.886.719-1.603 1.606-1.603.887 0 1.606.717 1.606 1.603v107.886c0 .886-.72 1.603-1.606 1.603m8.398 0a1.605 1.605 0 01-1.606-1.603V188.258c0-.886.72-1.603 1.606-1.603.887 0 1.606.717 1.606 1.603v107.886c0 .886-.719 1.603-1.606 1.603m8.399 0a1.604 1.604 0 01-1.606-1.603V188.258c0-.886.719-1.603 1.606-1.603.887 0 1.606.717 1.606 1.603v107.886c0 .886-.72 1.603-1.606 1.603m8.398 0a1.605 1.605 0 01-1.606-1.603V188.258c0-.886.72-1.603 1.606-1.603.887 0 1.606.717 1.606 1.603v107.886c0 .886-.719 1.603-1.606 1.603m8.399 0a1.604 1.604 0 01-1.606-1.603V188.258c0-.886.719-1.603 1.606-1.603.887 0 1.606.717 1.606 1.603v107.886c0 .886-.72 1.603-1.606 1.603m8.398 0a1.605 1.605 0 01-1.606-1.603V188.258c0-.886.72-1.603 1.606-1.603.887 0 1.606.717 1.606 1.603v107.886c0 .886-.719 1.603-1.606 1.603m8.399 0a1.604 1.604 0 01-1.606-1.603V188.258c0-.886.719-1.603 1.606-1.603.886 0 1.606.717 1.606 1.603v107.886c0 .886-.72 1.603-1.606 1.603m8.398 0a1.605 1.605 0 01-1.606-1.603V188.258c0-.886.72-1.603 1.606-1.603.887 0 1.606.717 1.606 1.603v107.886c0 .886-.719 1.603-1.606 1.603"
        fill="#4C4C4C"
      />
      <path
        d="M120.998 251.764c22.524-3.61 48.44-4.388 76.132-3.683 1.839-.09 3.244-1.927 3.138-4.105-2.824-13.562-3.785-29.754-2.325-44.28 1.15-4.389-1.696-7.55-3.535-7.462-25.396 5.474-50.773 6.776-76.132 3.683-1.839.09-3.243 1.927-3.138 4.105 2.621 14.211 3.692 34.092 2.34 47.96.105 2.177 1.681 3.871 3.52 3.782"
        fill="#F2E427"
      />
      <path
        d="M203.07 297.747a1.604 1.604 0 01-1.605-1.603V188.258c0-.886.719-1.603 1.606-1.603.886 0 1.606.717 1.606 1.603v107.886c0 .886-.72 1.603-1.606 1.603m8.398 0a1.605 1.605 0 01-1.606-1.603V188.258c0-.886.72-1.603 1.606-1.603.887 0 1.606.717 1.606 1.603v107.886c0 .886-.719 1.603-1.606 1.603m8.399 0a1.604 1.604 0 01-1.606-1.603V188.258c0-.886.718-1.603 1.606-1.603.886 0 1.605.717 1.605 1.603v107.886c0 .886-.719 1.603-1.605 1.603m8.398 0a1.604 1.604 0 01-1.606-1.602V188.257c0-.885.72-1.602 1.606-1.602.887 0 1.606.717 1.606 1.602v107.888c0 .885-.72 1.602-1.606 1.602m8.398 0a1.604 1.604 0 01-1.605-1.602V188.257c0-.885.718-1.602 1.605-1.602s1.606.717 1.606 1.602v107.888c0 .885-.719 1.602-1.606 1.602m8.399 0a1.604 1.604 0 01-1.606-1.602V188.257c0-.885.719-1.602 1.606-1.602.887 0 1.606.717 1.606 1.602v107.888c0 .885-.72 1.602-1.606 1.602m8.398 0a1.604 1.604 0 01-1.605-1.602V188.257c0-.885.719-1.602 1.605-1.602.887 0 1.606.717 1.606 1.602v107.888c0 .885-.719 1.602-1.606 1.602m8.399 0a1.605 1.605 0 01-1.606-1.603V188.258c0-.886.719-1.603 1.606-1.603.887 0 1.605.717 1.605 1.603v107.886c0 .886-.718 1.603-1.605 1.603m8.398 0a1.604 1.604 0 01-1.606-1.603V188.258c0-.886.72-1.603 1.606-1.603.887 0 1.606.717 1.606 1.603v107.886c0 .886-.719 1.603-1.606 1.603m8.399 0a1.605 1.605 0 01-1.606-1.603V188.258c0-.886.719-1.603 1.606-1.603.887 0 1.605.717 1.605 1.603v107.886c0 .886-.718 1.603-1.605 1.603"
        fill="#4C4C4C"
      />
      <path
        d="M202.038 247.421c22.752-1.644 48.638-.174 76.165 2.928 1.84.07 3.399-1.638 3.483-3.817-1.633-13.755-1.181-29.97 1.536-44.314 1.527-4.273-1.032-7.67-2.871-7.74-25.776 3.252-51.172 2.35-76.165-2.928-1.84-.071-3.4 1.638-3.483 3.817 1.374 14.384.711 34.283-1.843 47.98-.084 2.18 1.338 4.003 3.178 4.074"
        fill="#F2E427"
      />
      <path
        d="M287.055 297.747a1.605 1.605 0 01-1.606-1.603V188.258c0-.886.72-1.603 1.606-1.603.887 0 1.606.717 1.606 1.603v107.886c0 .886-.72 1.603-1.606 1.603m8.398 0a1.605 1.605 0 01-1.605-1.603V188.258c0-.886.719-1.603 1.605-1.603.888 0 1.607.717 1.607 1.603v107.886c0 .886-.72 1.603-1.607 1.603"
        fill="#4C4C4C"
      />
      <path
        d="M299.747 289.558H99.864c-8.636 0-1.689 19.906-20.214 19.897-4.317-12.191-8.625-41.415 13.745-57.553 29.95-22.992 191.027-20.712 212.82 0 26.45 18.29 16.493 47.23 12.9 57.272-18.786-1.127-8.55-18.002-19.368-19.616"
        fill="#FFF02C"
      />
      <path fill="#E2E6E8" d="M111.174 4.89h188.512V2.253H111.174z" />
      <path
        d="M115.397 3.097a3.1 3.1 0 01-3.104 3.098 3.1 3.1 0 01-3.103-3.098A3.1 3.1 0 01112.293 0a3.1 3.1 0 013.104 3.097m188.376.423a3.1 3.1 0 01-3.104 3.097 3.1 3.1 0 01-3.104-3.097A3.1 3.1 0 01300.67.422a3.1 3.1 0 013.104 3.098"
        fill="#E2E6E8"
      />
      <path fill="#F4F6F7" d="M.135 302.274h67.78V229.46H.134z" />
      <path fill="#F4F6F7" d="M0 308.71h15.198v-9.137H0zm52.716 0h15.198v-9.137H52.716z" />
      <path
        d="M36.354 245.34a2.327 2.327 0 01-2.33 2.323 2.327 2.327 0 01-2.328-2.324 2.327 2.327 0 012.329-2.324c1.286 0 2.329 1.041 2.329 2.324m0 37.042a2.326 2.326 0 01-2.33 2.324 2.327 2.327 0 01-2.328-2.324 2.327 2.327 0 012.329-2.324 2.327 2.327 0 012.328 2.324M.135 266.952h67.78v-1.085H.134z"
        fill="#FFF"
      />
      <path fill="#EBEBEB" d="M367.475 230.325h2.328v-31.62h-2.328z" />
      <path fill="#EBEBEB" d="M358.586 230.325h20.165V228h-20.165z" />
      <path fill="#FFF1E4" d="M389.697 202.408h-42.75l8.233-38.438h26.665l7.852 38.438" />
      <path
        d="M174.217 239.87c15.253-1.593 32.713-1.513 51.33-.555a2.242 2.242 0 002.22-2.265c-1.54-7.746-1.757-16.947-.39-25.154.89-2.466-.94-4.316-2.18-4.302-17.236 2.592-34.348 2.82-51.331.555a2.243 2.243 0 00-2.22 2.265c1.386 8.11 1.58 19.405.302 27.24a2.243 2.243 0 002.269 2.217"
        fill="#FFFFA1"
      />
    </g>
  </svg>
);

export default SvgNoBooked;
